import axios from "axios";
import Texts from "../Assets/json/text.json";

// export const baseURL = "http://localhost:3333"; //dev
export const baseURL = window.location.href.includes("doacaosangue.fiecdev") ? Texts.STATIC_URL_PROD : Texts.STATIC_URL_DEV; //prod

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
